<template>
    <transition name="success-pop">
        <div class="success-mask" v-if="visible">
            <div class="success-card">
                <svg class="success-icon" viewBox="0 0 52 52">
                    <circle class="success-circle" cx="26" cy="26" r="24" fill="none" />
                    <path class="success-check" fill="none" d="M14 27 l8 8 l16 -18" />
                </svg>
                <div class="success-text">{{ text }}</div>
                <div class="success-sub" v-if="sub">{{ sub }}</div>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * 全局成功提示弹窗（居中动画 + SVG 勾选 + 自动消失）
 * 用法（函数式，见 main.js 挂载的 this.$successToast）：
 *   this.$successToast({ text: '购买成功', sub: '订单已支付', duration: 2300 })
 * 也可作为组件使用：
 *   <success-toast ref="toast" />
 *   this.$refs.toast.show({ text, sub, duration })
 */
export default {
    name: 'SuccessToast',
    data() {
        return {
            visible: false,
            text: '操作成功',
            sub: '',
            duration: 2300,
            timer: null,
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
        }
    },
    methods: {
        show(options) {
            const opt = options || {}
            this.text = opt.text || '操作成功'
            this.sub = opt.sub || ''
            this.duration = opt.duration || 2300
            this.visible = true
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.visible = false
                if (typeof opt.onClose === 'function') opt.onClose()
            }, this.duration)
        },
        close() {
            this.visible = false
        },
    },
}
</script>

<style scoped>
/* 发布成功居中动画 */
.success-mask {
    position: fixed;
    inset: 0;
    z-index: 3000; /* 盖在 el-dialog（~2000）之上 */
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.28);
}
.success-card {
    width: 200px;
    height: 200px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: successCardIn 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.success-icon {
    width: 72px;
    height: 72px;
}
.success-circle {
    stroke: #67c23a;
    stroke-width: 3;
    stroke-dasharray: 151;
    stroke-dashoffset: 151;
    animation: successDrawCircle 0.5s ease forwards;
}
.success-check {
    stroke: #67c23a;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: successDrawCheck 0.35s 0.45s ease forwards;
}
.success-text {
    margin-top: 14px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    animation: successFadeUp 0.4s 0.7s ease both;
}
.success-sub {
    margin-top: 6px;
    font-size: 13px;
    color: #909399;
    animation: successFadeUp 0.4s 0.82s ease both;
}
@keyframes successCardIn {
    0% {
        transform: scale(0.6);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
@keyframes successDrawCircle {
    to {
        stroke-dashoffset: 0;
    }
}
@keyframes successDrawCheck {
    to {
        stroke-dashoffset: 0;
    }
}
@keyframes successFadeUp {
    0% {
        transform: translateY(8px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
/* 弹窗整体淡入/淡出 */
.success-pop-enter-active,
.success-pop-leave-active {
    transition: opacity 0.3s ease;
}
.success-pop-enter,
.success-pop-leave-to {
    opacity: 0;
}
</style>
